// extracted by mini-css-extract-plugin
export default {"overlay":"src-constrains-PopReminder-css__overlay--XdWZY"};